<script lang="ts">
  import { currentQuestion, surveyStatus } from '../../stores'

  let current =
    $surveyStatus.currentUserAnswer.length > 0 ? $surveyStatus.currentUserAnswer[0].text : null

  $: {
    $surveyStatus.currentUserAnswer = current
      ? [{ ...$currentQuestion.answers[0], text: current }]
      : [{ ...$currentQuestion.answers[0] }]
    $surveyStatus = $surveyStatus
  }
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === 'ArrowRight' && event.altKey) {
      event.preventDefault()
      current = 'TEST'
    }
  }}
/>

<label>
  <input type="text" placeholder="Scrivi la tua risposta..." bind:value={current} />
</label>

<style>
  input {
    width: 100%;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid white;
    border-radius: 0;
    color: white;
  }
  input:focus-visible {
    outline: 0;
  }
  input::placeholder {
    color: #7b7b7b;
  }
</style>
